import {TranslationFunction} from "../../i18n/i18n";
import {CatalogValueDto} from "../../client/catalog/CatalogValueDto";

export class CatalogFormatter {

    static formatCatalogValue(type: CatalogValueDto | null | undefined, catalogName: string, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(type?.code, catalogName, t);
    }

    static formatCatalogValueByCode(code: string | null | undefined, catalogName: string, t: TranslationFunction): string {
        if (code) {
            return t(`catalog:${catalogName}:${code}`);
        } else {
            return "";
        }
    }

    static formatNsCatalogValueByCode(code: string | null | undefined, namespace: string, t: TranslationFunction): string {
        if (code) {
            return t(`${namespace}:${code}`);
        } else {
            return "";
        }
    }

}
